import React from "react";
import { PrimaryButton } from "office-ui-fabric-react";
import { CardMedia, Grid } from "@material-ui/core";

import { BACKGROUND_COLOR } from "constants/colors";

import useStyles from "./styles";

type props = {
  onClickGetStarted: () => void;
};

const GetStarted = ({ onClickGetStarted }: props) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Grid container direction="column" justify="flex-start" alignItems="flex-start" className={classes.gridContent}>
        <Grid item  className={classes.item}>
          <div className={classes.itemLeft} />
          <div className={classes.itemRight}>
            <div className={classes.logo}>
              <CardMedia component="img" alt="logo" image="assets/logo-complete.svg" />
            </div>
            <span className={classes.headerText}>
              Optimiza al m&aacute;ximo la informaci&oacute;n de Hub en combinaci&oacute;n con Excel.
            </span>
            <div className={classes.line} />
          </div>
        </Grid>
        <Grid item  className={classes.item} style={{ marginTop: 24 }}>
          <div className={classes.itemLeft}>
            <img src="assets/icons/donlowad-icon.svg" alt="donlowad-icon" />
          </div>
          <div className={classes.itemRight}>
            Importa informaci&oacute;n de las tablas predefinidas al instante en Excel.
          </div>
        </Grid>
        <Grid item  className={classes.item}>
          <div className={classes.itemLeft}>
            <img src="assets/icons/document_check-icon.svg" alt="document_check-icon" />
          </div>
          <div className={classes.itemRight}>
            Mant&eacute;n actualizados tus modelos con informaci&oacute;n en tiempo real.
          </div>
        </Grid>
        <Grid item  className={classes.item}>
          <div className={classes.itemLeft}>
            <img src="assets/icons/check-list-icon.svg" alt="check-list-icon" />
          </div>
          <div className={classes.itemRight}>Lleva un mejor control de tu trabajo.</div>
        </Grid>
        <Grid container direction="row" justify="center" alignItems="center">
          <PrimaryButton onClick={onClickGetStarted} className={classes.buttonLogin}>
            ¡Comencemos!
          </PrimaryButton>
        </Grid>
      </Grid>
    </div>
  );
};

export default GetStarted;
